module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pageLoading),
      expression: "pageLoading"
    }],
    staticClass: "hwforget"
  }, [_c('div', {
    staticClass: "head"
  }, [_vm._v(_vm._s(_vm.$t('nav.mmp')))]), _vm._v(" "), (_vm.hasSetEmail) ? [_c('div', {
    staticClass: "tip"
  }, [(_vm.isNext) ? _c('p', [_vm._v(_vm._s(_vm.isfromPassSetting ? _vm.$t('overseaForget.enterFullEmail') : _vm.$t('overseaForget.enterAccount')))]) : _c('p', [_vm._v(_vm._s(_vm.$t('overseaForget.text1'))), _c('span', [_vm._v(_vm._s(_vm.emailAddr))]), _vm._v("," + _vm._s(_vm.$t('overseaForget.text2')))]), _vm._v(" "), (_vm.isNext && _vm.hiddenEmailAddr) ? _c('p', [_c('span', [_vm._v(_vm._s(_vm.hiddenEmailAddr))])]) : _vm._e()]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.formrules
    }
  }, [(_vm.isNext && !_vm.isfromPassSetting) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('overseaForget.loginAccount'),
      "prop": "useraccount"
    }
  }, [_c('el-input', {
    on: {
      "blur": function($event) {
        return _vm.getEmail()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.clearEmail($event)
      }
    },
    model: {
      value: (_vm.form.useraccount),
      callback: function($$v) {
        _vm.$set(_vm.form, "useraccount", $$v)
      },
      expression: "form.useraccount"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isNext) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('overseaForget.emailAddr'),
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "id": "email",
      "disabled": !_vm.isfromPassSetting
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  }), _vm._v(" "), (_vm.isErr) ? _c('span', {
    staticClass: "del"
  }, [_vm._v("+")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isNext) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('overseaForget.code'),
      "prop": "vCode"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "new-password"
    },
    model: {
      value: (_vm.form.vCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "vCode", $$v)
      },
      expression: "form.vCode"
    }
  }), _vm._v(" "), (_vm.isErr2) ? _c('span', {
    staticClass: "del"
  }, [_vm._v("+")]) : _vm._e(), _vm._v(" "), (_vm.resend) ? _c('p', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.$t('overseaForget.secend1') + _vm.countDown + _vm.$t('overseaForget.secend2')))]) : _vm._e(), _vm._v(" "), (!_vm.resend) ? _c('p', {
    staticClass: "count resend",
    on: {
      "click": function($event) {
        return _vm.resendCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('overseaForget.resend')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isNext && !_vm.isfromPassSetting) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('overseaForget.newPwd'),
      "prop": "newPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "new-password"
    },
    model: {
      value: (_vm.form.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.form, "newPassword", $$v)
      },
      expression: "form.newPassword"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isNext && _vm.isfromPassSetting) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('overseaForget.newManagementPassword'),
      "prop": "msgPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.form.msgPass),
      callback: function($$v) {
        _vm.$set(_vm.form, "msgPass", $$v)
      },
      expression: "form.msgPass"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isNext && _vm.isfromPassSetting) ? _c('el-form-item', {
    attrs: {
      "label": _vm.$t('overseaForget.confirmManagementPassword'),
      "prop": "rePass"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "new-password",
      "type": "password"
    },
    model: {
      value: (_vm.form.rePass),
      callback: function($$v) {
        _vm.$set(_vm.form, "rePass", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.rePass"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isNext) ? _c('div', {
    staticClass: "panel-header-btn panel-header-btn__fill",
    on: {
      "click": function($event) {
        return _vm.handleNext()
      }
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('overseaForget.next')))])]) : _c('div', {
    staticClass: "panel-header-btn panel-header-btn__fill",
    on: {
      "click": function($event) {
        return _vm.confirm('form')
      }
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v(_vm._s(_vm.$t('overseaForget.confirm')))])])], 1)] : _c('div', {
    staticClass: "no_email"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('overseaForget.msg.m1')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('overseaForget.msg.m2')))])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-e0fd6b8c"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/overseaforget/overseaforget.vue
// module id = 934
// module chunks = 0